import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton } from "@mui/material";
import { useCallback } from "react";
import { useDialogBetter } from "../../hooks/useDialogBetter";
import OfferManageDialog from "./OfferManageDialog";

export const OfferManageButton = (props) => {
    const { offer, onRefresh = () => {} } = props;
    const { openDialog } = useDialogBetter();

    const openManageOfferDialog = useCallback(
        () =>
            openDialog({
                Component: OfferManageDialog,
                componentProps: {
                    offer: offer,
                    refreshOffers: onRefresh,
                },
            }),
        [openDialog, offer, onRefresh],
    );

    return (
        <IconButton onClick={openManageOfferDialog}>
            <MoreVertIcon />
        </IconButton>
    );
};
